/**
 * @generated SignedSource<<e37cc3940c3d43abb58628af91abde59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpaceLayout_space$data = {
  readonly __typename: "Space";
  readonly canUpdate: {
    readonly value: boolean;
  };
  readonly color: {
    readonly dark: string;
    readonly light: string;
  };
  readonly id: string;
  readonly modules: ReadonlyArray<{
    readonly __typename: string;
    readonly id: string;
    readonly isSpaceActivityModule: "SpaceActivityModule";
    readonly isSpaceAnnouncementsModule: "SpaceAnnouncementsModule";
    readonly isSpaceEventsModule: "SpaceEventsModule";
    readonly isSpaceFamilyTreeModule: "SpaceFamilyTreeModule";
    readonly isSpaceFilesModule: "SpaceFilesModule";
    readonly isSpaceMembersModule: "SpaceMembersModule";
  }>;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceInfoModal_space">;
  readonly " $fragmentType": "SpaceLayout_space";
};
export type SpaceLayout_space$key = {
  readonly " $data"?: SpaceLayout_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceLayout_space">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpaceLayout_space",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SpaceInfoModal_space"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canUpdate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Color",
      "kind": "LinkedField",
      "name": "color",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "light",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dark",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "modules",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "isSpaceActivityModule",
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "type": "SpaceActivityModule",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "isSpaceAnnouncementsModule",
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "type": "SpaceAnnouncementsModule",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "isSpaceFilesModule",
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "type": "SpaceFilesModule",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "isSpaceEventsModule",
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "type": "SpaceEventsModule",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "isSpaceMembersModule",
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "type": "SpaceMembersModule",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "isSpaceFamilyTreeModule",
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "type": "SpaceFamilyTreeModule",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Space",
  "abstractKey": null
};
})();

(node as any).hash = "c19dcd8f123844055fea4033bcca4a33";

export default node;
